module.exports = __webpack_public_path__ + "img/play.9630c28b.svg";